/* eslint-disable space-before-function-paren */
import { HTTP } from '@/utils/http-common'
import { redirect } from '@/utils/common'

export default {
    list(parent) {
        return new Promise((resolve, reject) => {
            const projectId = parent.$route.params.project

            if (!projectId) {
                return resolve({ data: [] })
            }
            HTTP.get(`projects/manage/${projectId}/query/`)
                .then(response => resolve(response))
                .catch(err => {
                    parent.$store.commit('push', {
                        msg: `Errors : \n${_.join(
                            _.map(err.response.data, (el, label) => {
                                return label + ' : ' + el
                            }),
                            '\n'
                        )}`,
                        color: 'error',
                    })
                    return reject(err)
                })
        })
    },
    get(parent, query) {
        return new Promise((resolve, reject) => {
            HTTP.get(`query/manage/${query.id}/`)
                .then(response => resolve(response))
                .catch(err => {
                    parent.$store.commit('push', {
                        msg: `Errors : \n${_.join(
                            _.map(err.response.data, (el, label) => {
                                return label + ' : ' + el
                            }),
                            '\n'
                        )}`,
                        color: 'error',
                    })
                    return reject(err)
                })
        })
    },
    create(parent, query, project, parameters = null) {
        return new Promise((resolve, reject) => {
            query.parameters = parameters
            HTTP.post(`projects/manage/${project}/query/`, query)
                .then(response => resolve(response))
                .catch(err => {
                    parent.$store.commit('push', {
                        msg: `Errors : \n${_.join(
                            _.map(err.response.data, (el, label) => {
                                return label + ' : ' + el
                            }),
                            '\n'
                        )}`,
                        color: 'error',
                    })
                    return reject(err)
                })
        })
    },
    clone(parent, query, targetProject, cloneName = null) {
            const params = { target_project: targetProject }
            params.name = cloneName || query.name
            return HTTP.post(`query/manage/${query.id}/clone/`, params).then((result) => {
                parent.$store.commit('push', { msg: 'Query cloned successfully', color: 'success' })
                redirect(`projects/${parent.$route.params.project}/view/query/${result.data.id}`)
                return result
            }).catch((error) => {
                parent.$store.commit('push', { msg: error, color: 'error' })
                return error
            })
    },
    delete(parent, QueryName) {
        return new Promise((resolve, reject) => {
            HTTP.delete(`query/manage/${QueryName}/`)
                .then(response => {
                    parent.$router.replace(
                        '/projects/' + parent.$route.params.project
                    )
                    return resolve(response)
                })
                .catch(err => {
                    parent.$store.commit('push', {
                        msg: `Error : ${err}`,
                        color: 'error',
                    })
                    return reject(err)
                })
        })
    },
    update(parent, oldQuery, query, parameters = null) {
        return new Promise((resolve, reject) => {
            query.parameters = parameters
            return HTTP.put(`query/manage/${oldQuery.id}/`, query)
                .then(response => {
                    return resolve(response)
                })
                .catch(err => {
                    parent.$store.commit('push', {
                        msg: err.response.data.error,
                        color: 'error',
                    })
                    return reject(err)
                })
        })
    },
    patch(parent, oldQuery, query) {
        return new Promise((resolve, reject) => {
            return HTTP.patch(`query/manage/${oldQuery.id}/`, query)
                .then(response => resolve(response))
                .catch(err => {
                    parent.$store.commit('push', {
                        msg: err,
                        color: 'error',
                    })
                    return reject(err)
                })
        })
    },
    createOrUpdate(parent, query, project) {
        if (query.id) {
            return this.update(parent, query, project)
        } else {
            return this.create(parent, query, project)
        }
    },
    exec_query(parent, query, parameters = null) {
        return new Promise((resolve, reject) => {
            HTTP.get(`query/manage/${query.id}/results/`, { params: { parameters: parameters } })
                .then(response => resolve(response))
                .catch(err => {
                    parent.$store.commit('push', {
                        msg: `Error : ${err}`,
                        color: 'error',
                    })
                    return reject(err)
                })
        })
    },
    exec_anon(parent, query, project, parameters = null) {
        return new Promise((resolve, reject) => {
            HTTP.post('query/results/', {
                    project_id: project,
                    query: query.query,
                    parameters: parameters,
                })
                .then(response => resolve(response))
                .catch(err => {
                    parent.$store.commit('push', {
                        msg: `Error : ${err}`,
                        color: 'error',
                    })
                    reject(err)
                })
        })
    },
    exec(parent, query, project, parameters = null) {
        if (query.id) {
            return this.exec_anon(parent, query, project, parameters)
        }
        // return this.exec_query(parent, query, project)
        else {
            return this.exec_anon(parent, query, project, parameters)
        }
    },
}
